import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getImages } from '../Components/const'
import UseScrollReveal from '../Components/Common/UseScrollReveal '
import CustomerReviews from '../Components/Common/CustomerReviews'
import SeoMeta from '../Components/Common/SeoMeta'

const AboutStaff = () => {
    UseScrollReveal();

    const [teamList, setTeamList] = useState(null);

    console.log(teamList);

    useEffect(() => {
      // Access directly from the root URL
      fetch('/data/teamList.json')
        .then(response => response.json())
        .then(json => setTeamList(json));
    }, []);

    return (
        <>
            <SeoMeta
                title="About Us | Official McLaren Dealer in Orlando, FL | McLaren Orlando"
                description="Our car-loving team of trained and experienced professionals strive to uphold the McLaren goals of excellence. Visit McLaren Orlando today!"
                keywords=""
                ogTitle="About Us | Official McLaren Dealer in Orlando, FL | McLaren Orlando"
                ogDescription="Our car-loving team of trained and experienced professionals strive to uphold the McLaren goals of excellence. Visit McLaren Orlando today!"
            />
            <section className='common-banner-wrap'>
                <img src={getImages('about-bg.webp')} alt='about banner' />
                <div className='common-banner-pos pt-140'>
                    <div className='container'>
                        <div className='d-flex align-items-center'>
                            <div className='w-100'>
                                <h4 className='xs-title text-uppercase font-1-1em fw-300 text-lgray wow reveal fadeIn'>McLaren Orlando</h4>
                                <h1 className='lg-title text-uppercase mt-2 wow reveal fadeIn'>About Us</h1>
                                <div className='mt-4 wow reveal fadeIn'>
                                    <a href='#' className='theme-btn text-uppercase d-inline-block'>Contact Us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='common-wrap'>
                <div className='container'>
                    <h3 className='xs-title font-1-2em text-orange text-uppercase fw-bold'>The Staff</h3>
                    <h2 className='lg-title text-uppercase text-gray fw-300 mt-1 wow reveal fadeIn'>Meet Our Team</h2>
                    <div className='mt-3'>
                        <div className='row g-4'>
                            {teamList && teamList.map((item, index) =>
                                <div key={index} className='col-xl-3 col-md-4 col-sm-6 col-12 wow reveal fadeIn'>
                                    <div className='team-box'>
                                        <div className='team-image'>
                                            {item.image && <img src={getImages(item.image)} />}
                                        </div>
                                        <div className='team-content'>
                                            <div className='xs-title text-orange font-1-2em'>{item.name}</div>
                                            <div className='xs-title mt-2 mb-3'>{item.designation}</div>
                                            <div>
                                                <a href={`mailto:${item.email}`} className='sub-sm-btn d-block text-uppercase'>Email</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
            <CustomerReviews />
            <section className='common-wrap'>
                <div className='container'>
                    <div className='my-5'>
                        <h3 className='xs-title fw-bold text-orange text-uppercase mt-5 wow reveal fadeInUp'>About McLaren Orlando</h3>
                        <h2 className='lg-title text-gray fw-300 text-uppercase mt-1 wow reveal fadeInUp'>Prepare. Commit. Belong.</h2>
                        <div className='common-text wow reveal fadeInUp'>
                            <p>We are honored to be a member of McLaren Automotive and proudly serve the Orlando and Central Florida communities. Our car-loving team of trained and experienced professionals strive to uphold the McLaren goals of excellence and innovation, from sales to service and beyond.</p>

                            <p>Whether you live in a beautiful home on the coast, enjoy the views of a pristine golf course from your luxurious living room, or find yourself cruising and strolling along Park Ave – we have the McLaren that will fulfill your dreams. McLaren has much more to offer than just speed and thrill; McLaren in Orlando means there is a new bar for luxury customer care and exceptional cars.</p>

                            <p>We strive to provide our clients with nothing short of breathtaking performance and unparalleled experiences – from the vehicles we sell, to the services we provide, and the events we curate.</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AboutStaff